import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '~/styles/extended-theme';

const spinnerVariants = cva(
  'rounded-full inline-flex items-center justify-center text-sm font-medium font-mono uppercase ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      color: {
        default: '',
        primary: 'text-primary',
        white: 'text-white',
      },
      size: {
        default: 'h-8 w-8',
        xs: 'h-4 w-4',
        sm: 'h-8 w-8',
        md: 'h-12 w-12',
        lg: 'h-16 w-16',
        xl: 'h-32 w-32',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

export interface SpinnerProps extends VariantProps<typeof spinnerVariants> {
  showSpinner?: boolean;
  className?: string;
}

export function Spinner({ showSpinner, className, size, color }: SpinnerProps) {
  return (
    <div
      className={cn(
        'transition-opacity',
        showSpinner ? 'opacity-100' : 'opacity-0',
        spinnerVariants({ size, className, color }),
      )}
    >
      <svg
        className={cn('animate-spin', spinnerVariants({ size }))}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
      >
        <circle
          className="opacity-25"
          cx={12}
          cy={12}
          r={10}
          stroke="currentColor"
          strokeWidth={4}
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  );
}
